import type { Tutorial } from '@otter-ai/recall-client';
import { atom } from 'jotai';
import type { JSX } from 'react';

export type OverlayEntry = { key: string; component: JSX.Element };

export const currentOverlayComponent = atom<OverlayEntry | null>(null);

export const lastCompletedTutorialAtom = atom<Tutorial | null>(null);

// Tracks when the notetaker autojoin tooltip overlay is active (from Get Started flow)
// Used to prevent NotetakerSettingDialog from showing simultaneously
export const isAutojoinTooltipOverlayActiveAtom = atom<boolean>(false);
